/**
 * @generated SignedSource<<a962155d9fc3e2b188b94fd9b8d61849>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type statusField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly status: {
    readonly name: string | null;
  };
  readonly transitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly to: {
          readonly name: string | null;
        } | null;
        readonly transitionId: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "statusField_updateWorkItemAllFieldTypesActionRenderer";
};
export type statusField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: statusField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"statusField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "name"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "statusField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraTransitionConnection",
      "kind": "LinkedField",
      "name": "transitions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTransitionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraTransition",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "transitionId"
                },
                {
                  "concreteType": "JiraStatus",
                  "kind": "LinkedField",
                  "name": "to",
                  "plural": false,
                  "selections": (v0/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraStatusField"
};
})();

(node as any).hash = "0e0c841b03c9df5b0f83cb878e1419bc";

export default node;
